module.exports = __webpack_public_path__ + "img/propertynl.caa47d38.jpg";